import { AiOutlineLock } from "react-icons/ai";
import { MdVerified } from "react-icons/md";
import { PiPhoneCallFill } from "react-icons/pi";
import img3 from "../../images/23.png";
import img1 from "../../images/25.png";
import img2 from "../../images/evenement-entreprise.png";

const BenefitsSection = () => {
  const benefits = [
    {
      title: "Paiement sécurisé",
      icon: <AiOutlineLock className="text-3xl text-white sm:text-4xl" />,
      background: "bg-blue-100",
    },
    {
      title: "Espaces vérifiés",
      icon: <MdVerified className="text-3xl text-white sm:text-4xl" />,
      background: "bg-blue-100",
    },
    {
      title: "Flexibilité & aide",
      icon: <PiPhoneCallFill className="text-3xl text-white sm:text-4xl" />,
      background: "bg-blue-100",
    },
  ];

  return (
    <div className="py-8 bg-white md:py-12 lg:py-16 dark:bg-neutral-800">
      <div className="max-w-full px-4 mx-auto font-sans sm:max-w-2xl md:max-w-3xl lg:max-w-7xl">
        {/* Heading */}
        <h2 className="mb-4 text-2xl font-bold text-center text-gray-800 sm:text-3xl lg:text-4xl dark:text-white">
          Réservez mieux, vivez plus d’événements avec EventToBee
        </h2>

        {/* Description */}
        <p className="mb-8 text-sm text-center text-gray-600 sm:text-base dark:text-gray-500">
          Des espaces d’exception pour chaque moment qui compte Qu’il s’agisse d’un shooting, d’un anniversaire ou
          d’un séminaire, trouvez le lieu parfait.
        </p>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {/* Left Image (Meeting Room) */}
          <div className="overflow-hidden rounded-2xl h-[200px] sm:h-[250px] w-full">
            <img src={img1} alt="Meeting Room" className="object-cover w-full h-full" />
          </div>
          <div
            className={`flex flex-col items-center justify-center ${benefits[0].background} rounded-2xl p-4 h-[200px] sm:h-[250px] w-full`}
          >
            <div className="flex items-center justify-center w-12 h-12 mb-4 rounded-full bg-eventToBee sm:w-16 sm:h-16">
              {benefits[0].icon}
            </div>
            <p className="text-sm font-semibold text-center text-gray-800 sm:text-base">{benefits[0].title}</p>
          </div>

          <div className="overflow-hidden rounded-2xl h-[200px] sm:h-[250px] w-full">
            <img src={img2} alt="Meeting Room" className="object-cover w-full h-full" />
          </div>

          <div
            className={`flex flex-col items-center justify-center ${benefits[1].background} rounded-2xl p-4 h-[200px] sm:h-[250px] w-full`}
          >
            <div className="flex items-center justify-center w-12 h-12 mb-4 rounded-full bg-eventToBee sm:w-16 sm:h-16">
              {benefits[1].icon}
            </div>
            <p className="text-sm font-semibold text-center text-gray-800 sm:text-base">{benefits[1].title}</p>
          </div>

          <div className="overflow-hidden rounded-2xl h-[200px] sm:h-[250px] w-full">
            <img src={img3} alt="Meeting Room" className="object-cover w-full h-full" />
          </div>

          <div
            className={`flex flex-col items-center justify-center ${benefits[2].background} rounded-2xl p-4 h-[200px] sm:h-[250px] w-full`}
          >
            <div className="flex items-center justify-center w-12 h-12 mb-4 rounded-full bg-eventToBee sm:w-16 sm:h-16">
              {benefits[2].icon}
            </div>
            <p className="text-sm font-semibold text-center text-gray-800 sm:text-base">{benefits[2].title}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BenefitsSection;
